import { useFormik } from "formik";
import { validationSchema } from "../validations/validationMessageTemplates";
export const useFormikMessageTemplate = ({ onSubmit }) => {
  return useFormik({
    initialValues: {
      step: 1,
      name: "",
      fallback: "",
      parameters: "",
      rcsmessage: "",
      buttonQuickReplies: [],
      buttonActions: [],
      title_rcs_message: "",
      imageUrl: "",
      thumbnail_url: "",
      height: "",
      category: "",
      status: true,
      carrousel: [],
      cardOrientation: "",
    },
    validationSchema: validationSchema,
    onSubmit: (payload) => {
      const request = cleanPayload(payload);
      onSubmit(request);
    },
  });
};

const cleanPayload = (payload) => {
  return Object.fromEntries(
    Object.entries(payload).map(([key, value]) => [
      key,
      value === "" ? null : value,
    ]),
  );
};
